// import external dependencies
import $ from 'jquery'
// Import everything from autoload
import './autoload/_bootstrap.js'
// import 'odealim-second/scripts/shared'

// import local dependencies
import Router from './util/Router'
import common from './routes/common'
import home from './routes/home'

import aboutUs from './routes/about'
import templateFaq from './routes/faq'

/** Populate Router instance with DOM routes */
const routes = new Router({
    // All pages
    common,
    // Home page
    home,
    // About Us page, note the change from about-us to aboutUs.
    aboutUs,
    templateFaq
})

// Load Events
$(document).ready(() => routes.loadEvents())

console.log('*** ODEALIM - MAIN THEME ***')

// Hot reload apply
if (module.hot) {
    module.hot.accept()
}
